// extracted by mini-css-extract-plugin
module.exports = {"chart":"chart___3wtPX"};